import React, { useState, useRef, useContext } from 'react';
import ENVIRONMENT from '../../../../environments';
import axios from 'axios';
import * as Utilities from '../../Utilities';
import * as Constants from "../Constants";
import * as JSZip from 'jszip';

import {
    Button, Modal, Row, Card, Col, Upload,
    message,
    Spin
} from 'antd';
import { ArrowLeftOutlined, DeleteOutlined, LoadingOutlined } from '@ant-design/icons';
import CollaborateQAContext from '../../ContextFiles/CollaborateQAContext';
import { useEffect } from 'react';
const { Dragger } = Upload


const CUSTOMER_USERNAME = localStorage.getItem('username');
const COMPANY_ID = localStorage.getItem("company_id");
const SHARED_ENTITIES = localStorage.getItem("shared_entities");

const AddReferenceImages = () => {
    const { setOpenProductImageSelectionModal, setErrorMessage, errorMessage, assetUploading,
        uploadMoreAssets, product_id, refImgModal, setRefImgModal, productAssetData } = useContext(CollaborateQAContext);

    const [filesList, setFilesList] = useState([]);
    const draggerRef = useRef(null);
    const [uploadKey, setUploadKey] = useState(Date.now());

    const cancelAddRefImages = () => {
        setFilesList([]);
        setRefImgModal(false);
        setErrorMessage('');
        setUploadKey(Date.now()); // force remount

    }

    const isValidExt = (file, type) => {
        const allowedExtensions = type;

        const isAllowed = allowedExtensions.some(ext => file.name.toLowerCase().endsWith(ext));
        return isAllowed;
    }

    const validateFile = async (file) => {
        const allowedExtensions = ['.jpg', '.jpeg', '.png', '.obj', '.glb', '.zip', '.gltf'];
        const name = file.name.toLowerCase();
        const isAllowedExtension = allowedExtensions.some(ext => name.endsWith(ext));

        if (!isAllowedExtension) {
            message.error("Only JPG, PNG, OBJ, and GLB files are allowed.");
            return false;
        }

        // ZIP validation
        if (name.endsWith('.zip')) {
            try {
                const zip = await JSZip.loadAsync(file);
                const topLevelFiles = Object.values(zip.files).filter(f => !f.dir && !f.name.includes('/'));

                const hasOBJ = topLevelFiles.some(f => f.name.toLowerCase().endsWith('.obj'));
                const hasGLB = topLevelFiles.some(f => f.name.toLowerCase().endsWith('.glb'));
                const hasGLTF = topLevelFiles.some(f => f.name.toLowerCase().endsWith('.gltf'));

                if (!hasOBJ && !hasGLB && !hasGLTF) {
                    message.error("ZIP must contain at least one .obj, .glb or .gltf file at top level.");
                    return false;
                }

                return true;
            } catch (err) {
                console.error("Invalid ZIP:", err);
                message.error("Invalid ZIP file.");
                return false;
            }
        }

        return true;
    };


    const uploadProps = {
        ...(Constants.getUploadProps(productAssetData['platform'])),
        multiple: true,
        accept: ".jpg,.jpeg,.png,.obj,.glb,.zip,.gltf",
        beforeUpload: async (file) => {
            if (refImgModal) {
                const isValid = await validateFile(file);
                if (!isValid) return false;
                else {return true;}
            } else {
                setFilesList([]);
                return false;
            }
        },
        fileList: refImgModal ? filesList : [],
        onChange: (info) => {
            console.log(info)
            if (!refImgModal) {
                setFilesList([]);
                return;
            }
            // Merge the new files with the existing list, avoiding duplicates by UID
            setFilesList((prevList) => {
                const mergedList = [...prevList, ...info.fileList];
                return [...new Map(mergedList.map(file => [file.uid, file])).values()];
            });

            const { status } = info.file;
            if (status === "error") {
                if (info?.file?.error?.code?.includes('Credentials')) {
                    message.error('Your session has expired. Please reload the page.')
                }
                else {
                    message.error(`${info.file.name} file upload failed.`);
                }
            }
        },
        onDrop(e) {
            console.log("Dropped files", e.dataTransfer.files);
        },
    };

    const goBack = () => {
        setFilesList([]);
    }

    const openProductLibrary = () => {
        setOpenProductImageSelectionModal(true);
        setRefImgModal(false);
    }


    useEffect(() => {
        if (refImgModal) {
            setFilesList([]);
        }
    }, [refImgModal]);


    return (
        <Modal
            className={`add-ref-image-popup ${filesList?.length > 0 ? `ref` : ``}`}
            destroyOnClose={true}
            maskClosable={false}
            closable={true}
            title={filesList?.length == 0 ? '' : <div className="manrope f-14 lh-22 w-500 black-085"><ArrowLeftOutlined className={`cursor-pointer ${filesList?.length > 0 ? `` : `disp-none`}`}
                onClick={goBack} />&nbsp;
                Add Reference Assets</div>}
            visible={refImgModal}
            onCancel={cancelAddRefImages}
            footer={[
                filesList.length > 0 && <>
                    <div className={'justify-in-end'}>
                        <Button disabled={assetUploading} className="nav-btns black-grey f-14 pd-16-11" onClick={cancelAddRefImages}>
                            Cancel
                        </Button>
                        <Button disabled={assetUploading} loading={assetUploading} className="nav-btns blue-fill f-14 pd-16-11" onClick={() => uploadMoreAssets(filesList, setFilesList)}>
                            Add
                        </Button>
                    </div>
                    {errorMessage && <div className='manrope f-12 red mt-5'>{errorMessage}</div>}
                </>
            ]}>
            <Row>
                <Col md={24} lg={24} xl={24}>
                    {filesList?.length == 0 ? <>
                        <h1 className='manrope f-20 lh-28 black-085 w-500 mb-24'>Add Reference Assets</h1>
                        <Col span={24}>
                            <div ref={draggerRef} style={{ margin: "0 auto", position: "relative", zIndex: 1 }}>
                                <Dragger
                                    key={uploadKey}
                                    className="upload-height-170 reference-img-dragger"
                                    {...uploadProps}>
                                    <div className="manrope">
                                        <div style={{ color: "black" }} >Drag & Drop or</div>
                                        <span className="mt-10" style={{ border: "1px solid #D9D9D9", display: 'inline-block', borderRadius: 4, padding: "8px 10px", color: "black" }}>+ Add images or 3D files</span>
                                        <div className="mt-10" style={{ fontSize: 12, color: "#595959" }}>
                                            Supported formats: JPG, PNG, OBJ, and GLB
                                        </div>
                                    </div>
                                </Dragger>
                            </div>
                            <div class="ref-asset-divider manrope f-14 black-085 w-500 lh-22">
                                <span>or</span>
                            </div>
                            <Button className='nav-btns black pd-12 f-14 width-imp' onClick={openProductLibrary}>
                                Select from product library
                            </Button>
                        </Col>
                    </> :
                        <>
                            <h1 className='manrope f-20 lh-28 black-085 w-500 mb-24'>Add images or 3D files</h1>

                            <Col span={24} className="file-list-container mt-10">
                                {filesList.map((file) => (
                                    <div
                                        key={file.uid}
                                        className="ai-uploaded-file-card">
                                        {file.status === "uploading" ? (
                                            <div className="loader">
                                                <Spin indicator={<LoadingOutlined spin />} style={{ color: '#8C8C8C' }} size="large" />
                                            </div>
                                        ) : (
                                            <>
                                                <div className="image-wrapper">
                                                    {file.type?.startsWith("image/") ?
                                                        <img
                                                            className="ai-file-card-image"
                                                            src={ENVIRONMENT.getBaseURL(productAssetData['platform']) + "test_files" + "/" + file.uid + "/" + encodeURIComponent(file.name)}
                                                            alt={file.name}
                                                        /> :
                                                        isValidExt(file, ['obj']) == true ?
                                                            <img className="ai-file-card-image" src="/img/obj_icon.png" /> :
                                                            isValidExt(file, ['glb']) == true || isValidExt(file, ['gltf']) == true ?
                                                                <img className="ai-file-card-image" src="/img/glb_file.png" /> :
                                                                <img className="ai-file-card-image" src="/img/zip_file.png" />
                                                    }
                                                </div>
                                                <Button
                                                    shape="circle"
                                                    onClick={() => {
                                                        setFilesList((prevList) => prevList.filter(item => item.uid !== file.uid))
                                                    }
                                                    }
                                                    icon={<DeleteOutlined style={{ color: 'red' }} />}
                                                    className="ai-img-delete-button"
                                                />
                                            </>
                                        )}
                                    </div>
                                ))}
                                <div>
                                    <Dragger className="dragger-height-132 manrope" {...uploadProps} showUploadList={false} style={{ height: 132, width: 132, border: "1px dashed #595959", borderRadius: 8, background: "white" }}>
                                        <div style={{ color: 'black' }}>Drag & Drop or </div>
                                        <span className="button-inside-upload mt-10" style={{ border: "1px solid #D9D9D9", display: 'inline-block', borderRadius: 4, padding: "4px 10px", color: "black" }}>+ Add</span>
                                    </Dragger>
                                </div>
                            </Col>
                        </>}
                </Col>

            </Row>
        </Modal>)

}

export default AddReferenceImages;